import React from "react";
import styled from "styled-components";

function Header() {
  return (
    <Head>
      <Title>Become a Full Stack Web Developer</Title>
      <Desc>
        <p>
          So you want to become a full stack web developer in the quickest time
          possible? Well, maybe you can do it quickly, but I would definitely
          recommend to do it in the 'right' order.
        </p>
        <p>
          Learn the basics of HTML, CSS and JavaScript first, as almost
          everything else builds on this foundation knowledge and will make it
          much much easier as you move on!
        </p>
      </Desc>
    </Head>
  );
}

const Head = styled.div``;

const Title = styled.h1`
  color: #196895;
  padding-top: 20px;
  font-family: Pacifico, serif;
  font-weight: 400;
  font-size: 2.8rem;
`;

const Desc = styled.div`
  padding-bottom: 40px;

  p {
    color: #777;
    padding-top: 15px;

    padding-left: 40px;
    font-size: 1rem;
    max-width: 700px;
    width: 90%;
  }
`;

export default Header;
